import { UserRequestModel } from "libs/models/user-model";
import { ValidationModel } from "libs/models/validate-model";
import { UserStore } from "store/slices/users";
import translate from "utils/translations";

export const validateEditUserState = (
  state: UserStore
): ValidationModel<UserRequestModel> => {
  let validationModel = {} as ValidationModel<UserRequestModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (
    state.updateUserData.firstName === undefined ||
    state.updateUserData.firstName === ""
  ) {
    validationModel.firstName = translate(
      "Required_Text",
      "This field is required"
    );
  } else if (/\d/.test(state.updateUserData.firstName)) {
    validationModel.firstName = translate(
      "Invalid_Data_Text",
      "Name cannot contain numbers"
    );
  }
  if (
    state.updateUserData.lastName === undefined ||
    state.updateUserData.lastName === ""
  ) {
    validationModel.lastName = translate(
      "Required_Text",
      "This field is required"
    );
  } else if (/\d/.test(state.updateUserData.lastName)) {
    validationModel.lastName = translate(
      "Invalid_Data_Text",
      "Name cannot contain numbers"
    );
  }

  if (
    state.updateUserData.email === null ||
    state.updateUserData.email === ""
  ) {
    validationModel.email = translate(
      "Required_Text",
      "This field is required"
    );
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (
    state.updateUserData.email !== "" &&
    !emailRegex.test(state.updateUserData.email)
  ) {
    validationModel.email = translate("Email_Error", "Invalid email address");
  }
  if (
    state.updateUserData.roleId === null ||
    state.updateUserData.roleId === undefined
  ) {
    validationModel.roleId = translate(
      "Required_Text",
      "This field is required"
    );
  }
  return validationModel;
};
